var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.payout.deliv)?_c('v-btn',{attrs:{"small":""},on:{"click":function($event){return _vm.submit()}}},[_vm._v("Update Deliv")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }